/* eslint-disable semi */
<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;bottom: 12px;height: 175px; top: 330px;left: 270px;transform: translate(-50%, -50%);border: 1px solid #23fffc;border-radius: 10px;}
.title{height: 35px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #23fffc;}
/deep/.el-form-item {margin-bottom: 5px;}
/deep/.radius .el-input__inner {width: 180px; border-radius: 20px 0px 0px 20px; border-right: none;}
/deep/.radius .el-input-group__append {width: 70px;padding: 0;border-radius: 0px 20px 20px 0px;border: solid 1px #3c818d;background: rgba(10, 17, 43, 0.4);border-left: none;}
.el-button {border-radius: 20px;border: solid 1px #3c818d;}
.el-button--primary {color: #FFF;background-color: rgba(33, 185, 191, 0.6);}
.el-button--default {color: #FFF;background: rgba(10, 17, 43, 0.4);}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>缓冲区分析</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="缓冲区类型：">
          <el-select v-model="form.type" placeholder="请选择缓冲区类型" disabled>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缓冲半径：">
          <el-input placeholder="请输入内容" v-model="form.radius" class="radius">
            <template slot="append">/100Km</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickmap">确定</el-button>
          <el-button @click="closePul(false)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data()
  {
    return {
      flag: false,
      form: {
        type: 'Circle',
        radius: null
      },
      options:
      [
        {
          value: 'Circle',
          label: '点'
        }, {
          value: 'LineString',
          label: '线'
        }
      ]
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.form.radius = null
      this.flag = show
      if (!this.flag)
        this.$store.commit('searchtype', false)
    },
    clickmap()
    {
      if (this.form.radius)
      {
        this.$store.commit('searchtype', true)
        this.$emit('bufferanalysis', this.form)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Buffer.vue